var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 378,
    viewBox: "0 0 380 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1403 0C14.8083 7.93582 6.10161 16.4044 0.628906 36.0747L18.6765 378H352.165C372.903 366.931 379.266 350.44 379.629 299.577C369.333 197.51 356.77 139.329 338.041 36.0747C328.597 21.7603 326.544 12.2025 289.391 10.9793L46.1403 0Z",
    fill: "#652784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterPurple);
export default __webpack_public_path__ + "static/media/CenterPurple.ed8666e6b3251d2c86e09a2533abf76a.svg";
export { ForwardRef as ReactComponent };